import React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// graphql
import { BUSINESS_PROCESSES_TREE_QUERY } from 'graphql/businessProcess/queries'
// types
import { TRefetch } from 'types/refetch'
import { NetworkStatus } from '@apollo/client'
import { IBusinessProcessesResponse, IBusinessProcessesQueryArgs, IBusinessProcess } from 'types/graphql'
// utils
import get from 'lodash/get'
import { getOr, maxBy, pipe } from 'lodash/fp'

type Props = React.PropsWithChildren<unknown>

type QueryResponse = { businessProcesses: IBusinessProcessesResponse }

interface Context {
  refetch: TRefetch<QueryResponse, IBusinessProcessesQueryArgs>
  isLoading: boolean
  lastPosition: number
  businessProcesses: IBusinessProcess[]
}

export const BusinessProcessesAPIContext = React.createContext<Context>({} as any)

const BusinessProcessesAPI: React.FC<Props> = ({ children }) => {
  const {
    data: treeQuery,
    refetch,
    loading,
    networkStatus
  } = useQuery<QueryResponse>(BUSINESS_PROCESSES_TREE_QUERY, {
    variables: {
      pagination: {
        pageSkip: 0,
        pageTake: 10000
      }
    }
  })

  const businessProcesses: IBusinessProcess[] = (get(treeQuery, 'businessProcesses.data') || []).map(
    (businessProcess) => ({
      ...businessProcess,
      title: businessProcess.description
    })
  )

  const lastPosition: number = pipe<any, any, any>(maxBy('position'), getOr(0, 'position'))(businessProcesses)

  const value = {
    refetch,
    lastPosition,
    businessProcesses,
    isLoading: loading && networkStatus === NetworkStatus.loading
  }

  return <BusinessProcessesAPIContext.Provider value={value}>{children}</BusinessProcessesAPIContext.Provider>
}

export default BusinessProcessesAPI
